<template>
    <div class="popup-mass-edit-vat-mode">
        <el-dialog :modelValue="true" width="480" class="flex-column" @close="$emit('close')">
            <template #title>
                <span class="fs-5 bold">{{ $l10n.__('Modifier le mode de TVA') }}</span>
                <div class="semibold alert alert-info mt-3">
                    {{
                        $l10n.__(
                            "Une fois enregistrées, les modifications peuvent prendre plusieurs secondes à s'appliquer.",
                        )
                    }}
                </div>
            </template>
            <div>
                <div v-for="(pref, key) in prefsSelected" :key="key">
                    <el-divider v-if="key >= 1"></el-divider>
                    <p class="pb-1">
                        {{ $l10n.__('Mode de TVA à mettre à jour') }}
                        <i
                            v-if="prefsSelected.length > 1"
                            class="icon-trash fright gray-60 hover-gray-80"
                            @click="onRemovePref(key, pref)"
                        ></i>
                    </p>
                    <el-select
                        ref="selectVatMode"
                        v-model="selectedLabel"
                        class="wp-10"
                        :placeholder="$t.__('forms.PopupMassEditVatMode.vat_mode')"
                    >
                        <el-option
                            v-for="item in prefsForDropDown"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                            data-test="vatmode"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        @click="$emit('close')"
                    />
                    <CompassButton
                        :label="$t.__('common.actions.save')"
                        type="primary"
                        :disabled="selectedLabel === ''"
                        @click="save()"
                    />
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import FormMixins from '../../mixins/FormMixins';

export default {
    mixins: [FormMixins],
    props: {
        rows: {
            type: Array,
        },
        emitEditSuccess: {
            type: String,
            required: false,
            default: 'listing:refresh',
        },
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            selectedLabel: '',
            prefsForDropDown: [
                {
                    id: '1',
                    label: this.$l10n.__('TVA sur les débits'),
                    value: 'debit',
                },
                {
                    id: '2',
                    label: this.$l10n.__('TVA sur les encaissements'),
                    value: 'collection',
                },
            ],
            prefsSelected: [{}],
            metas: {},
            overlay: null,
        };
    },
    methods: {
        save: function () {
            const payload = {
                selectedModels: [],
                vatMode: '',
            };
            this.populatePayload(payload);
            this.$ajax.put(
                '/rest/model/batch/vatmode',
                {},
                _.toPlainObject(payload),
                (response) => {
                    EventBus.emit(this.emitEditSuccess);
                    this.$emit('close');
                    Push.success(this.$l10n.__('Modification effectuée.'));
                },
                (error) => {
                    Push.error(
                        this.$l10n.__(
                            'Une erreur est survenue lors de la mise à jour du mode de TVA.',
                        ),
                    );
                },
            );
        },
        populatePayload(payload) {
            payload.selectedModels = this.rows;
            payload.vatMode = this.selectedLabel;
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.popup-mass-edit-vat-mode {
    div > p > i {
        cursor: pointer;
    }

    .el-dialog__wrapper .el-dialog.flex-column {
        max-height: 800px;
        border-radius: 4px;

        .el-dialog__header {
            padding-bottom: 24px;

            button i {
                color: $gray-100;
            }
        }
    }
}
</style>
